import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppSessionStorage } from '../storage/app.session-storage';

@Injectable()
export class ContextHttpInterceptor implements HttpInterceptor {
    private readonly appSessionStorage = inject(AppSessionStorage);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const contextRequest = request.clone({
            headers: request.headers.set('ctx', this.appSessionStorage.getCurrentContext() || '')
        });

        return next.handle(contextRequest);
    }
}
